<!-- @format -->

<div class="module-content-application-structure">
  <div class="mca-border">
    <div class="accordion-panel accordion-panel-noblock-dotted-content">
      <div class="header">
        <a class="collapse disabled" role="button" aria-hidden="true">
          <sis-icon [icon]="'chevron-ring'" [color]="'light'" [iconClass]="'cw-90'"
        /></a>
        <div class="title">
          <span>{{ parentModule.name | localizedString }}</span>
          @if (parentModule.code) {
            <span class="additional">{{ parentModule.code }}</span>
          }
        </div>
      </div>
      <div class="content">
        <div class="content-row">
          <div class="content-text">
            <div class="row">
              @for (courseUnit of selectedCourseUnits; track courseUnit) {
                <div class="col-sm-6">
                  <sis-course-unit-box
                    [courseUnit]="courseUnit"
                    [attainment]="selectedCourseUnitAttainmentsByGroupId[courseUnit.groupId]"
                    [categoryCssClass]="'cu-color-1'"></sis-course-unit-box>
                </div>
              }
              @for (customCourseUnitAttainment of selectedCustomCourseUnitAttainments; track customCourseUnitAttainment) {
                <div class="col-sm-6">
                  <sis-custom-course-unit-attainment-box [attainment]="customCourseUnitAttainment" [categoryCssClass]="'cu-color-1'">
                    @if (customStudyDraftsById[customCourseUnitAttainment.customStudyDraftId]) {
                      <div notifications>
                        <sis-tooltip
                          [tooltipText]="
                            ('SIS_COMPONENTS.MODULE_CONTENT_APPLICATION_STRUCTURE.REPLACES_CUSTOM_STUDY_DRAFT' | translate) +
                            ' ' +
                            customStudyDraftsById[customCourseUnitAttainment.customStudyDraftId].name
                          ">
                          <div class="cu-notification sis-tooltip-trigger-content">
                            <span class="cu-notification-header"><sis-icon icon="info"></sis-icon></span
                            ><!--
                              --><span class="cu-notification-content">
                              <span translate="SIS_COMPONENTS.MODULE_CONTENT_APPLICATION_STRUCTURE.REPLACES_CUSTOM_STUDY_DRAFT"></span>:
                              {{ customStudyDraftsById[customCourseUnitAttainment.customStudyDraftId].name }}
                            </span>
                          </div>
                        </sis-tooltip>
                      </div>
                    }
                  </sis-custom-course-unit-attainment-box>
                </div>
              }
              @for (customStudyDraft of effectiveCustomStudyDrafts; track customStudyDraft) {
                <div class="col-sm-6">
                  <sis-plan-custom-study-draft [customStudyDraft]="customStudyDraft"></sis-plan-custom-study-draft>
                </div>
              }
              @for (module of modules; track module) {
                <div class="col-sm-6">
                  <sis-module-box [module]="module" [attainment]="selectedModuleAttainmentsByGroupId[module.groupId]"></sis-module-box>
                </div>
              }

              @for (customModuleAttainment of selectedCustomModuleAttainments; track customModuleAttainment) {
                <div class="col-sm-6">
                  <sis-custom-module-attainment-box [attainment]="customModuleAttainment"></sis-custom-module-attainment-box>
                </div>
              }
              @for (groupingModule of groupingModules; track groupingModule) {
                <div class="col-sm-12">
                  <sis-module-box [module]="groupingModule"></sis-module-box>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
